<!-- Hero Header -->
<div class="cart-hero">
    <div class="container cart-hero__inner">
        <div class="cart-hero__breadcrumb">
            <i class="fa fa-home"></i>
            <a routerLink="/home">Home</a>
            <span class="sep">/</span>
            <i class="fa fa-shopping-cart"></i>
            <span class="current">Shopping Cart</span>
        </div>
        <div class="cart-hero__title">
            <i class="fa fa-shopping-cart"></i>
            <span>Your Shopping Cart</span>
        </div>
        <div class="cart-hero__subtitle">Review your items and proceed to checkout</div>
    </div>
</div>
<div class="container mb-5 wrapper-content">

    <mycart-layout
        *ngIf="cartListDetails?.length"
        (onUpdateCartValue)="updateCartValue($event)"
        [cartListDetails]="cartListDetails"
        [optionList]="optionList"
        [discount]="discount"
        [discountPercent]="discountPercent"
        (payOutEvent)="onProceed($event)"
        [payOutDetail]="payOutDetail"
        [sum]="sum"
        (navigateToaddress)="navigateToaddress($event)"
        (onRemoveItem)="getItemId($event)">
    </mycart-layout>

    <ngx-skeleton-loader
        *ngIf="!flag2"
        count="5"
        [theme]="{ 'border-radius': '12px', height: '56px' }">
    </ngx-skeleton-loader>
    <div class="row mt-3" *ngIf="!cartListDetails?.length">
        <div class="col-md-10 m-auto">
            <div class="right-side cart-empty-card">
                <div class="row" *ngIf="isLoading">
                    <img class="m-auto" src="assets/latest/empty.svg" alt="">
                </div>
                <div *ngIf="isLoading">
                    <h3 class="emptyHead">
                        Your Cart is Empty
                    </h3>
                    <p class="emptyPara">
                        Looks like you have not added anything to your cart
                        Go ahead & explore top categories.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="flag">
    <div class="container mt-5" *ngIf="serviceData?.length">
        <div class="cart-recommend-header">
            <h2 class="cart-recommend-title">
                YOU MAY ALSO LIKE
            </h2>
        </div>
        <div class="items cart-recommend-items mt-4">
            <div class="slick_slider">
                <div class="service_slider_new slider slider-customize d-flex">
                    <ng-container *ngFor="let data of serviceData; let i = index">
                        <div class="slider-card">
                            <product-card [data]="data" (on_Click)="goToProduct(data?._id)"></product-card>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>


<div class="modal fade" id="modalDeleteConfirmation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered cart-delete-modal" role="document">
        <div class="modal-content ggg cart-delete-modal__content">
            <div class="cart-delete-modal__icon-wrapper">
                <img
                    class="for-img1 cart-delete-modal__icon"
                    src="assets/latest/trashicon.png"
                    alt="Remove item" />
            </div>
            <h2 class="modal-title okay cart-delete-modal__title">
                Are you sure you want<br />
                to remove this item?
            </h2>

            <div class="modal-body cart-delete-modal__actions">
                <button
                    type="button"
                    class="btn cart-delete-btn-secondary"
                    data-dismiss="modal">
                    No
                </button>
                <button
                    type="button"
                    class="btn cart-delete-btn-primary"
                    data-dismiss="modal"
                    (click)="removeCartList()">
                    Yes
                </button>
            </div>
        </div>
    </div>
</div>